var Buf = require('buf');
var BufferFormatter = require('bufferformatter');
var Member = require('member');
var User = require('user');


var InputInfoView = Backbone.View.extend({
    tagName: 'div',
    className: 'inputInfo',
    initialize: function (options) {
        this.visible = false;
        this.formatter = new BufferFormatter(this.model);
        
        this.model.bind('remove', this.remove, this);
    },
    renderTimedelay: 300,
    events: {
        'click a': 'clickItem',
        'click span.item': 'clickItem'
    },
    clickItem: function (e) {
        var item = $(e.currentTarget).closest('span.item');
        if (item.is('.original')) {
            this.makeOriginalChoice();
        } else {
            var index = item.data('index');
            this.makeChoice(index);
        }
        return false;
    },
    makeChoice: function (index) {
        this.trigger('makeInputChoice', index);
        this.hide();
    },
    makeOriginalChoice: function () {
        this.trigger('makeInputOriginalChoice');
        this.hide();
    },
    renderCandidates: function (word, candidates, highlight, emoji) {
        if (highlight !== undefined && candidates[highlight]) {
            return this.show(word, candidates, highlight);
        } else if (emoji && candidates.length) {
            return this.show(word, candidates);
        } else {
            return this.hide();
        }
    },
    isVisible: function () {
        return this.visible;
    },
    show: function (word, candidates, highlight) {
        this.word = word;
        
        var nodes = _.map(candidates, function (c, i) {
            var node = $('<span class="item">');
            if (highlight === i) {
                node.addClass('highlight');
            }
            if (c instanceof Member && c.isAway()) {
                node.addClass('away');
            }
            node.data('index', i);
            var name;
            if (c instanceof User) {
                name = c.getName();
                var displayAuthor = c.getDisplayAuthor();
                if (displayAuthor && displayAuthor != name) {
                    name = displayAuthor + ' (' + name + ')';
                }
                var html = this.formatter.linkUserMode(c, {
                    name: name
                });
                if (c.isAway()) {
                    html += ' (away)';
                }
                node.html(html);
                if (!this.word && c.lastHighlighted) {
                    var hlDate = new Date(c.lastHighlighted);
                    var timeago = $('<span class="hlago">').attr('title', hlDate.toISOString()).text(hlDate.formatFullDate()).timeago();
                    node.append(' ', timeago);
                }
            } else if (c instanceof Buf) {
                name = c.getName();
                if (c.isServerLog()) {
                    name = c.getFullLabel();
                }
                node.html(this.formatter.linkModel(c, {
                    name: name
                }));
            } else if (c.emoji) {
                node.html(emoji.replacement(c.emoji, '', c.title, undefined, undefined, c.skinTone));
            } else {
                node.text(c);
            }
            return node;
        }, this);
        this.$('.hlago').timeago('dispose');
        this.$el.html(nodes);
        
        if (this.word) {
            var orig = $('<span class="original item">').text(this.word);
            if (!candidates[highlight]) {
                orig.addClass('highlight');
            }
            this.$el.prepend(orig);
        }
        
        // Hint text
        var text;
        if (candidates.length == 1) {
            text = 'Press tab or esc to dismiss';
        } else {
            text = 'Press tab to autocomplete (esc to dismiss)';
        }
        this.$el.prepend($('<span class="hint">').text(text));
        
        if (!this.isVisible()) {
            this.$el.show();
            this.visible = true;
        }
        return this;
    },
    hide: function () {
        if (this.isVisible()) {
            this.$el.hide();
            this.visible = false;
        }
        return this;
    }
});


module.exports = InputInfoView;



//////////////////
// WEBPACK FOOTER
// ./app/src/view/inputinfoview.js
// module id = vMiC
// module chunks = 1